// MDMS Application Entry Point
// This file imports all JavaScript modules and CSS

// Import SCSS (webpack with sass-loader will process this)
import '../css/spa.scss';

/**
 * MDMS Main Application Bundle
 * This imports and organizes all JavaScript modules from public/js
 */

// Import JavaScript modules
import './modules/bootstrap.js';         // Bootstrap initialization
//import './modules/dom.js';               // DOM utilities
//import './modules/requests.js';          // AJAX request helpers
//import './modules/sidebar.js';           // Sidebar functionality
//import './modules/datatable.js';         // DataTable configurations
//import './modules/realtime.js';          // Real-time updates
//import './modules/timeseries.js';        // Time series functionality
import { page } from './modules/page.js';
//import './modules/extra.js';             // Additional features
//import './modules/reporting.js';         // Dashboard reporting functionality

// Import utility modules
//import './modules/utils/assets.js';
//import './modules/utils/dialog.js';
//import './modules/utils/forms.js';
//import './modules/utils/map.js';
//import './modules/utils/text_editor.js';
//import './modules/utils/code.js';
//import './modules/utils/utils.js';

// Application initialization when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    console.log('🧫 MDMS Application loaded successfully');

    // Initialize application
    try {
        if (window.MDMSApp) {
            window.MDMSApp.init();
        }
    } catch (error) {
        console.error('Failed to initialize MDMS Application:', error);
    }

    // Hide splash screen
    const splash = document.getElementById('splash');
    if (splash) splash.style.display = 'none';

    // Global error handler for production debugging
    window.addEventListener('error', function(e) {
        console.error('MDMS App Error:', e.error);
    });

    // Service worker registration for caching (future enhancement)
    //if ('serviceWorker' in navigator && 'production' === process.env.NODE_ENV) {
    //    navigator.serviceWorker.register('/sw.js');
    //}
});

// Global MDMS Application object
window.MDMSApp = {
    version: '1.0.0',
    environment: process.env.NODE_ENV || 'development',

    init() {

        // bootstrap Site
        page.bootstrapSite();

        /*
        // Initialize sidebar functionality
        window.mdms.sidebar.init();
        
        // tooltips
        jQuery('[data-toggle="tooltip"]').tooltip();
        
        // Initialize DataTables
        jQuery(function ($) {
            $("#dt-search-0").attr('placeholder', 'Search').addClass("form-control-sm rounded-md float-left light-bg");
        });

        // autocomplete
        try {
            var cache = {};
            $(".autocomplete").each(function(){
                if ($(this).prop('readonly')) {
                    return;
                }
                mdms.form.autocomplete.register($(this), cache);
            });
        } catch (error) {}

        // initialize dirty forms
        try {
            $('form.save-me').each(function (){
                $(this).dirtyForms();
            });
        } catch (error) {}

        // Initialize page helpers
        mdms.pageHelpers.init();

        console.log(`🚀 MDMS Application v${this.version} initialized in ${this.environment} mode`);
        this.initUserPreferences();
        */
    },

    initUserPreferences() {
        // Load user preferences from localStorage
        const theme = localStorage.getItem('mdms_theme') || 'light';
        document.documentElement.setAttribute('data-theme', theme);
    },

    // Utility methods for modules
    showNotification(message, type = 'info') {
        // Implement notification system
        console.log(`[${type.toUpperCase()}] ${message}`);
    },

    // Error logging
    logError(error, context) {
        console.error('[MDMS Error]', error, context);
        // Future: send to error tracking service
    }
};
